import { useState, useEffect } from 'react';

function useFetch(url) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  async function fetchUrl() {
    try {
      const response = await fetch(url);
      const json = await response.json();
      setData(json.landingDesc);
      setLoading(false);
    } catch (error) {
      setData('Error!!!');
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchUrl();
    // eslint-disable-next-line
  }, []);
  return [data, loading];
}

export default useFetch;
